export default __webpack_public_path__ + "static/media/promocionAlarma6.9eb54253.png";